export default {
    trendradar: {
        title: 'Trend radar'
    },
    megatrend: {
        title: 'Mega-trend',
        relevance: '<strong>1</strong> macro-trend of this mega-trend are part of the trend radar. | <strong>{count}</strong> macro-trends of this mega-trend are part of the trend radar.'
    },
    deprecated: {
        title: 'The following macro-trends found in this trend radar are no longer part of the current Trendone trend universe:',
        recommendation: 'We strongly recommend activating the new trend universe. Old trends will remain in the trend radar regardless.'
    }
}
